<template>
    <div class="dm-set-password mb-5">
		<div class="form-group row">
			<label class="col-xl-3 col-lg-3 col-form-label text-right">New Password</label>
			<div class="col-xl-9 col-lg-9">
				<input type="password" class="form-control" value="" placeholder="New password" v-model="user_data.password" @keyup="$emit('changesMade')">
                <small class="fw-bold">Password must be at least 8 characters long.</small>
			</div>
		</div>
		<div class="form-group row">
			<label class="col-xl-3 col-lg-3 col-form-label text-right">Verify Password</label>
			<div class="col-xl-9 col-lg-9">
				<input type="password" class="form-control" value="" placeholder="Verify password" v-model="user_data.password_confirmation" @keyup="$emit('changesMade')">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['user_data'],
}
</script>
